export default [{
	titulo: 'Vacinados',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/vacinados',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]